'use client';
import LayoutProvider from '../layout/context/layoutcontext';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import '../styles/layout/layout.scss';
import '../styles/demo/Demos.scss';

export default function RootLayout({ children }) {
    return (
        <LayoutProvider>
            <PrimeReactProvider>
                {children}
            </PrimeReactProvider>
        </LayoutProvider>
    );
}
